import React from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';

import { makeStyles } from '@material-ui/core/styles';
import PoweredByFN from './PoweredByFN';
import VerticalTimeLineCard from './VerticalTimeLineCard';

const useStyles = makeStyles({
  root: {
    maxWidth: '100%',
	marginTop: 20,
    paddingBottom: 30,
    paddingLeft: 20,
	paddingRight: 20
  },
  cardTitleText: {
    marginTop: 30,
    marginBottom: 10,
    color: '#333333',
    fontSize: 24,
    fontWeight: 600,
    letterSpacing: 0,
  },
  poweredBy: {
	marginTop: 20
  }
});

function getCareerItems(member) {
	return member.positions.map(position => {
		let endDate;
		if (undefined === position.endDate) {
			endDate = "Present";
		} else {
			endDate = position.endDate.split("-")[0];
		}
		const startDate = position.startDate.split("-")[0];
		return {primary: position.title, secondary: startDate.concat("-", endDate)}
	});
}

const CareerHistoryCard = (member = {}) => { 

	try {
		const classes = useStyles();

		if (undefined === member ||
			undefined === member.positions)
			{
				return null;
			}

		return (
			<Card className={classes.root}>
				<div className={classes.cardTitleText}>Political Career History</div>
				<Grid container justify="center">
					<VerticalTimeLineCard items={getCareerItems(member)}/>
				</Grid>
				<div className={classes.poweredBy}>
					<PoweredByFN/>
				</div>
			</Card>
		);
	} catch (err) {
		return null;
	}

}

export default CareerHistoryCard;